import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-privilege',
  templateUrl: './modify-privilege.component.html',
  styleUrls: ['./modify-privilege.component.css']
})
export class ModifyPrivilegeComponent implements OnInit {

  editForm: any | FormGroup
  privilege:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  screenPrivilegeList: any= []
  singlePrivilege:any = []
  updatePrivilegeList: any= []
  screenPrivilegeScopeList :any = []
  privilegeId: any = "";
  cid:any

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllPrivileges()
    // this.addScreenPrivilegeList()
    // this.editForm = this.fb.group({
    //   groupName: [''],
    //   seqNo: [''],
    //   name: [''],
    //   description: [''],
    //   controllerName: [''],
    //   type: [''],
    //   serverPrivilege: [''],
    // })
  
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllPrivileges();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllPrivileges();
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }





  addScreenPrivilegeList(i:any){
    this.updatePrivilegeList[0].screenPrivilegeList.splice(i+1, 0,
      {
        "seqNo": 0,
        "name": "",
        "description": "",
        "screenPrivilegeScopeList": [
          {
            "controllerName": "",
            "type": "",
            "serverPrivilege": ""
          }
        ]
      }
    )
  }

  addScreenPrivilegeScopeList(i: any){
    this.updatePrivilegeList[0].screenPrivilegeList[i].screenPrivilegeScopeList.push(
      {
        "controllerName": "",
        "type": "",
        "serverPrivilege": ""
      }
    )
 

  }


  removeScreenPrivilegeList(i:any){
    console.log(i)
    this.updatePrivilegeList[0].screenPrivilegeList.splice(i,1)
    console.log(this.screenPrivilegeList)
  }

  removeScreenPrivilegeScopeList(i:any,j:any){
    console.log(i)
    console.log(j)
    this.updatePrivilegeList[0].screenPrivilegeList[i].screenPrivilegeScopeList.splice(j,1)

    console.log(this.screenPrivilegeList)
  }
  
  getAllPrivileges(){
    this.generic_service.getAllPrivileges().subscribe(
      (response:any)=>{
        this.privilege = response.response;
        console.log(response)
      }
    )
  }


  updatePrivilege(){
    let body = {
      "id": this.updatePrivilegeList[0].id,
      "screenGroupId":this.privilegeId,
      "version": Number(this.updatePrivilegeList[0].version),
      "isActive": this.updatePrivilegeList[0].isActive,
      "description": String(this.updatePrivilegeList[0].description),
      "seqNo": Number(this.updatePrivilegeList[0].seqNo),
      "groupName": String(this.updatePrivilegeList[0].groupName),
      "screenPrivilegeList": this.updatePrivilegeList[0].screenPrivilegeList,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.updatePrivilege(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.getAllPrivileges()
        this.toastr.success("Successfully updated");
        this.cancelModel()
      },
      (error:any)=>{
        this.toastr.error(error.errors[0].description);
      }
    )
  }

  getPrivilegeByID(id:any){
    this.privilegeId = id
    this.generic_service.getPrivilegeById(id).subscribe(
      (res:any)=>{
        this.updatePrivilegeList = [];
        // console.log(res);
        this.updatePrivilegeList.push(res.response)
        console.log(this.updatePrivilegeList);
      }
    )
  }

}
